import { render } from "./verifymessage.vue?vue&type=template&id=80f4c880&scoped=true&class=font-nunito"
import script from "./verifymessage.vue?vue&type=script&lang=js"
export * from "./verifymessage.vue?vue&type=script&lang=js"

import "./verifymessage.vue?vue&type=style&index=0&id=80f4c880&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-80f4c880"

export default script